import React from "react";
import { Tooltip } from "antd";
import MediaQuery from "react-responsive";
import Help from "../../../../../../assets/images/dashboard/help-icon.svg";
import ArrowBlack from "../../../../../../assets/images/dashboard/arrow-black.svg";
import Plus from "../../../../../../assets/images/dashboard/plus.svg";
import Minus from "../../../../../../assets/images/dashboard/minus.svg";
import Equal from "../../../../../../assets/images/dashboard/equal.svg";
import Rate from "../../../../../../assets/images/dashboard/rate.svg";
import Prize from "../../../../../../assets/images/dashboard/prize.svg";
import CardDetailsByGraph from "../component/CardDetailsByGraph"
import SeeMoreDetails from "../component/SeeMoreDetails"
import SeeMoreDetailsRewards from "../component/SeeMoreDetailsRewards";
import SeeMoreDetailsFeatures from "../component/SeeMoreDetailsFeatures";
import CardInfoPanel from "../component/CardInfoPanel";
import Carousel from "react-multi-carousel";
import {
    getCardImageURL,
    getFeaturesIcon,
    commaSeparator,
    valueWithCommas,
    getToolTipConstant,
    toFixedToDecimal,
    firstYear,
    secondYear,
    lastYear
} from "../../../../../../utils/constants"
import "../../../../../../common/styles/dashboard.scss"
import './CardDetails.scss';


function CardDetailsCarousel(args)  {
    
    const { 
        getCardsList,
        onGetDate,
        avgSpending,
        spending,
        selectedDate,
        topYearProjection, 
        topIncludedIntroBonus,
        selectedCategories,
        selectedFeatures,
    } = args;
    
    // 
    const [isRewardsExpanded, setIsRewardsExpanded] = React.useState(false);
    const [isFeaturesExpanded, setIsFeaturesExpanded] = React.useState(false);
    const [carouselHeight, setCarouselHeight] = React.useState(null);
    const carouselRef = React.useRef(null);
    const carouselIndexRef = React.useRef(null);
    
    // 
    const updateCarouselHeight = (nextSlide) => {
        if (carouselRef.current) {
            setTimeout(() => {
                let currentSlide = carouselRef.current.state.currentSlide;
                let slideIndex = nextSlide === 0 ? 0 : nextSlide || currentSlide;
                const height = carouselRef.current.containerRef.current.querySelectorAll('.tab-card-data')[slideIndex]?.offsetHeight;
                if (height) {
                    const extraHeightForDots = 30;
                    setCarouselHeight(height + extraHeightForDots);
                }
            }, 50); // delay required for this to work reliably
        }
    };
    
    // trigger height adjustment
    const prevArgs = React.useRef({});
    if (prevArgs.current.topYearProjection != topYearProjection) {
        prevArgs.current.topYearProjection = topYearProjection;
        setTimeout(() => updateCarouselHeight(), 10); // delay needed for this to work
    }
    if (prevArgs.current.topIncludedIntroBonus != topIncludedIntroBonus) {
        prevArgs.current.topIncludedIntroBonus = topIncludedIntroBonus;
        setTimeout(() => updateCarouselHeight(), 10); // delay needed for this to work
    }
    if (prevArgs.current.selectedCategories != JSON.stringify(selectedCategories)) {
        prevArgs.current.selectedCategories = JSON.stringify(selectedCategories);
        setTimeout(() => updateCarouselHeight(), 10); // delay needed for this to work
    }
    if (prevArgs.current.selectedFeatures != JSON.stringify(selectedFeatures)) {
        prevArgs.current.selectedFeatures = JSON.stringify(selectedFeatures);
        setTimeout(() => updateCarouselHeight(), 10); // delay needed for this to work
    }
    if (prevArgs.current.cardIds != JSON.stringify(getCardsList().map(el => el.id))) { // cards changed
        prevArgs.current.cardIds = JSON.stringify(getCardsList().map(el => el.id));
        setTimeout(() => updateCarouselHeight(), 10); // delay needed for this to work
        // if card length is less than current slide index, go to last slide
        if (carouselIndexRef.current && getCardsList().length <= carouselIndexRef.current) {
            carouselRef.current.goToSlide(getCardsList().length-1);
        }
    }
    
    //
    React.useEffect(() => {
        window.addEventListener('resize', () => {
            updateCarouselHeight();
        });
        window.addEventListener('orientationchange', () => {
            updateCarouselHeight();
        });
    }, []);
    
    // 
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1300 },
            items: 1,
            partialVisibilityGutter: 0,
        },
        tablet: {
            breakpoint: { max: 1300, min: 991 },
            items: 1,
            partialVisibilityGutter: 0,
        },
        mobile: {
            breakpoint: { max: 991, min: 0 },
            items: 1,
            partialVisibilityGutter: 0,
        }
    };
    
    //
    return "DEPRECATED";
    
    // 
    return (
        
        <div className="top-carousel-root" style={{ height: carouselHeight }}>
            <Carousel
                ref={carouselRef}
                ssr
                partialVisible={true}
                deviceType={"desktop"}
                customTransition="all 0.3s cubic-bezier(0.16, 1, 0.3, 1)"
                responsive={responsive}
                itemClass="tab-card-data-container"
                showDots={true}
                renderDotsOutside={true}
                beforeChange={(nextSlide) => {
                    updateCarouselHeight(nextSlide);
                    carouselIndexRef.current = nextSlide;
                }}
            >
                {(getCardsList().slice(0, 10) || []).map((card, index) => {
                    return (
                        <CardInfoPanel {...{...args, 
                            key: index,
                            card, 
                            index, 
                            updateCarouselHeight,
                            isRewardsExpanded, setIsRewardsExpanded,
                            isFeaturesExpanded, setIsFeaturesExpanded,
                        }}/>
                    );
                })}
            </Carousel>
        </div>
    );
}

export default CardDetailsCarousel;
